export default {
    nl: {
        intro: {
            subtitle: 'AWS',
            title: 'Een goede host.',
            contact: 'Neem contact op',
            image: 'https://23g-website.s3.eu-central-1.amazonaws.com/services/aws/hero.jpg',
        },
        type: 'AWS',
        title: 'Ontdek onze AWS-gecertificeerde expertise voor de cloud',
        description:
            'AWS is leidend cloud service met enorme schaalbaarheid. Wij bieden AWS-gecertificeerde expertise en inzichten over cloud oplossingen',
        content: [
            {
                type: 'text',
                title: 'AWS',
                content: `
                    Als je denkt aan cloud computing, denk je al snel aan Amazon Web Services, of kortweg AWS. Amazon heeft met AWS iets speciaals op de markt gebracht. Het heeft zich met dit platform gevestigd als de meest toonaangevende cloud serviceprovider. Wereldwijd vertrouwen bedrijven en ontwikkelaars op AWS om diverse IT-infrastructuur diensten en innovatieve cloud oplossingen te leveren.
                    <br><br>
                    We zijn er trots op dat al onze developers AWS-gecertificeerd zijn. Voor elke klant betekent dit dat je samenwerkt met een toegewijd team dat de kneepjes van het vak kent. Samen zorgen we voor solide en vooruitstrevende cloud oplossingen die naadloos aansluiten bij wat jouw organisatie nodig heeft.
                `,
            },
            {
                type: 'text',
                title: 'De kracht van schaalbaarheid',
                content:
                    'Wat AWS onderscheidend maakt is de mate van schaalbaarheid. Gebruikers hebben de vrijheid om hun resources naar wens aan te passen - of dat nu opschalen is tijdens piekuren of afschalen tijdens rustige periodes. Het mooie hiervan? Je betaalt alleen voor wat je daadwerkelijk nodig hebt. Zo vinden bedrijven een perfecte balans tussen kosten en prestaties, afgestemd op hun behoeften.',
            },
            {
                type: 'images',
                images: ['https://23g-website.s3.eu-central-1.amazonaws.com/services/vegas.webp'],
            },
            {
                type: 'text',
                title: '23G goes USA',
                content: `
                    Elk jaar organiseert Amazon het AWS re:Invent. Deze conferentie staat bekend als een van de meest prominente cloud computing-evenementen ter wereld. Het evenement trekt duizenden deelnemers, variërend van ontwikkelaars en IT-experts tot architecten en zakelijke leiders. Natuurlijk zijn wij hier ook van de partij!
                    <br><br>
                    Tijdens het evenement worden er talloze sessies, workshops en presentaties georganiseerd, die een breed scala aan onderwerpen bestrijken, zoals cloud architectuur, serverloze computing, kunstmatige intelligentie, machine learning, beveiliging, databeheer en nog veel meer. AWS-experts en klanten delen hun ervaringen en succesverhalen, waardoor deelnemers waardevolle inzichten krijgen over hoe ze AWS-effectiever kunnen gebruiken in hun eigen projecten en organisaties.
                    <br><br>
                    Gedurende dit evenement duiken we in een reeks boeiende sessies, workshops en presentaties. Onderwerpen als cloud architectuur, serverloze computing, kunstmatige intelligentie en machine learning staan centraal. Het is voor ons ook een geweldige kans om dieper in thema's te duiken als API management en beveiliging. Als kers op de taart delen AWS-professionals en hun klanten hun persoonlijke succesverhalen, waardoor we bruikbare inzichten mee naar huis nemen voor onze eigen projecten.
                `,
            },
            {
                type: 'case',
                case: 'nines',
            },
        ],
        related_services: ['back-end-development', 'strategy-session', 'front-end-development'],
        contact: {
            title: '',
            employee: 'jack',
        },
    },
    en: {},
};
